import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-lg-4 col-md-6 col-12" }
const _hoisted_2 = { class: "itemcard downloadcard" }
const _hoisted_3 = ["href"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "downloadbtn" }
const _hoisted_6 = ["href"]


// eslint-disable-next-line vue/no-setup-props-destructure

export default /*#__PURE__*/_defineComponent({
  props: {
  card: Object,
},
  setup(__props) {

const { card } = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: __props.card.link
      }, [
        _createElementVNode("img", {
          src: __props.card.img,
          alt: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("h2", null, _toDisplayString(__props.card.title), 1)
      ], 8, _hoisted_3),
      _createElementVNode("p", null, _toDisplayString(__props.card.description), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          href: __props.card.link
        }, _toDisplayString(__props.card.linkTitle), 9, _hoisted_6)
      ])
    ])
  ]))
}
}

})